import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckSquare } from 'lucide-react';
export function Agitation() {
  const checkboxes = ['Tu hijo lleva más de 2 horas seguidas mirando una pantalla y no escucha cuando lo llamas.', 'Cuando finalmente apagas el dispositivo, el berrinche dura más que la película que estaba viendo.', 'Ya probaste los castigos, las negociaciones, los gritos... y nada funciona de forma consistente.', 'Te sientes culpable por darle la tablet... pero también te la das para tener un momento de paz.', 'A veces piensas que algo está "mal" en tu hijo cuando en realidad está completamente normal.'];
  return <section className="w-full py-24 px-6 bg-white relative overflow-hidden" data-id="element-12">
      {/* Decorative background element */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-cream-dark/30 rounded-l-[100px] -z-10 transform translate-x-1/4" data-id="element-13"></div>

      <div className="max-w-3xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-4xl md:text-5xl font-bold text-charcoal mb-12 text-center" data-id="element-16">
            Dime si esto te suena familiar...
          </h2>
        </FadeIn>

        <div className="space-y-6 mb-16" data-id="element-17">
          {checkboxes.map((text, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-18">
              <div className="flex items-start gap-4 p-6 bg-white rounded-2xl shadow-sm border border-cream hover:border-terracotta/30 transition-colors group" data-id="element-19">
                <div className="mt-1 shrink-0" data-id="element-20">
                  <CheckSquare className="w-7 h-7 text-terracotta group-hover:scale-110 transition-transform" data-id="element-21" />
                </div>
                <p className="text-lg md:text-xl text-charcoal-light leading-relaxed" data-id="element-22">
                  {text}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-23">
          <div className="text-center space-y-8" data-id="element-24">
            <p className="text-2xl md:text-3xl font-serif font-bold text-charcoal" data-id="element-25">
              Si marcaste aunque sea 2 de estas casillas...
            </p>

            <div className="inline-block bg-charcoal text-white px-8 py-4 rounded-xl" data-id="element-26">
              <p className="text-xl font-medium" data-id="element-27">
                Necesitas el Plan Cero Gritos.{' '}
                <span className="text-terracotta-light" data-id="element-28">
                  Y lo necesitas ahora.
                </span>
              </p>
            </div>

            <div className="max-w-2xl mx-auto space-y-6 text-lg text-charcoal-light" data-id="element-29">
              <p data-id="element-30">
                Porque cada semana que pasa sin un sistema claro, el cerebro de
                tu hijo se está reconfigurando para depender más de esa
                estimulación artificial.
              </p>
              <p className="text-xl font-medium text-terracotta" data-id="element-31">
                Y cada berrinche que termina en grito... debilita el vínculo que
                tanto has construido.
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}